module.exports = require("./naq");